import type { DesktopPlatform } from './api';

type BrowserPlatform = {
  userAgent?: string;
  platform?: string;
  maxTouchPoints?: number;
  userAgentData?: { platform?: string; mobile?: boolean };
};

/** A download suggestion only: browsers may hide or override these hints. */
export function detectDesktopPlatform(browser: BrowserPlatform): DesktopPlatform | null {
  const agent = browser.userAgent ?? '';
  const platform = browser.userAgentData?.platform || browser.platform || agent;
  if (
    browser.userAgentData?.mobile ||
    /android|iphone|ipad|ipod|mobile|cros/i.test(`${platform} ${agent}`)
  )
    return null;
  // iPadOS can identify as a Mac when requesting the desktop site.
  if (/mac/i.test(platform) && (browser.maxTouchPoints ?? 0) > 1) return null;
  if (/mac/i.test(platform)) return 'macos';
  if (/win/i.test(platform)) return 'windows';
  if (/linux/i.test(platform)) return 'linux';
  return null;
}

/**
 * Apple devices show the Command symbol for the search shortcut: macOS, iPhone, iPad and iPod, including iPadOS
 * reporting itself as a Mac with a touch screen (its keyboard still sends Meta). Windows, Linux, ChromeOS and
 * Android show Ctrl. A label hint only: unlike detectDesktopPlatform it never picks a download.
 */
export function isApplePlatform(browser: BrowserPlatform): boolean {
  const agent = browser.userAgent ?? '';
  const platform = browser.userAgentData?.platform || browser.platform || '';
  if (/^(mac|iphone|ipad|ipod)/i.test(platform)) return true;
  if (platform) return false;
  return /iphone|ipad|ipod|macintosh/i.test(agent);
}
